import { Skeleton } from 'antd';

export type DrawerSkeletonProps = {
  /** Announced while loading, e.g. "Loading replacement requests". */
  label: string;
};

/**
 * The loading placeholder shared by the order-scoped request drawers — `orders/replacements`' listing
 * and Ticket Preview, and `orders/warranty`' listing. It lives in `orders/components/` rather than in
 * either submodule because it is the one genuinely identical piece of the two surfaces (ADR-0023; the
 * drawers themselves are deliberately duplicated).
 *
 * The `aria-hidden` wrapper is the load-bearing part, not decoration: antd's `Skeleton` paragraph
 * renders its placeholder rows as `<ul><li/></ul>`, so their implicit `listitem` roles leak into
 * `findAllByRole('listitem')` and collide with the real list. Hiding the placeholder while keeping
 * the outer `role="status"` visible means the loading state is still announced. It lives here so
 * that workaround exists once — duplicated, a fix to one copy would silently miss the other.
 */
export function DrawerSkeleton({ label }: DrawerSkeletonProps) {
  return (
    <div role="status" aria-label={label}>
      <div aria-hidden="true">
        <Skeleton active paragraph={{ rows: 6 }} />
      </div>
    </div>
  );
}
